import * as customPopUp from './views/modals/customPopUp.js';
import LANG from '../lang/prop-en-module.js';

const langOTP = LANG.otp;
const cognitoApi = new CognitoApi();

function userMyInfoRetrieve(callback) {
  const body = {};
  const methodPath = '/occo-owner/user/my-info/retrieve';
  const hasApiKey = true;
  _occoApiPostRequestBase(hasApiKey, methodPath, body, false, callback);

  function _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback) {
    const showErr = hasApiKey || showApiErrors || window.DEBUG_MODE;
    const ajaxParams = {
      url: process.env.BACKEND_API + methodPath,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(body),

      success(resp, textStatus, jqXHR) {
        if (resp.status == 'ok') {
          callback(null, resp.result);
        } else if (resp.status == 'nok') {
          const err1 = {};
          err1.type = 'occo';
          err1.message_key = showErr ? resp.error_message_key : 'Internal Error';
          err1.message_text = showErr ? resp.error.message_text : 'Internal Error';
          err1.textStatus = textStatus;
          err1.jqXHR = jqXHR;
          err1.resp = resp;
          console.error('err', JSON.stringify(err1));
          callback(err1, null);
        } else {
          const err2 = {};
          err2.type = 'occo';
          err2.message_key = 'Internal Error';
          err2.jqXHR = jqXHR;
          err2.textStatus = textStatus;
          err2.resp = resp;
          console.error('err', JSON.stringify(err2));
          callback(err2, null);
        }
      },
      error(jqXHR, textStatus, errorThrown) {
        if (jqXHR.readyState == 0 || jqXHR.status == 0) {
          return; // it's not really an error,
          // it's accure when user refresh page before ajax call complition
        }
        const err = {};
        err.type = 'global';
        err.message_key = 'Internal Error';
        err.jqXHR = jqXHR;
        err.textStatus = textStatus;
        err.errorThrown = errorThrown;
        console.error('err', JSON.stringify(err));
        callback(err, null);
      },
    };
    if (hasApiKey) {
      cognitoApi.getApiKey((err, apiKey) => {
        if (err) {
          location.href = './';
          // callback(err, null);
          return;
        }
        ajaxParams.headers = {
          Authorization: apiKey,
        };
        $.ajax(ajaxParams);
      });
    } else {
      $.ajax(ajaxParams);
    }
  }
}

function CognitoApi() {
  /// ///////////public methods
  this.login = function (username, password, callback) {
    const authenticationData = {
      Username: username,
      Password: password,
    };

    const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
    const cognitoUser = _getCognitoUser(username);

    const totpMfaSettings = {
      PreferredMfa: true,
      Enabled: true,
    };

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess(result) {
        cognitoUser.getUserData(async (err, data) => {
          if (err) {
            alert(err.message || JSON.stringify(err));
            return;
          }

          const { PreferredMfaSetting } = data;

          try {
            if (PreferredMfaSetting !== 'SOFTWARE_TOKEN_MFA' && isEnabledMFA(data)) {
              await setupMFA();
            }

            userMyInfoRetrieve((err, user) => {
              if (err) {
                callback.onFailure(err);
              } else {
                callback.onSuccess(user);
              }
            });
          } catch (err) {
            cognitoApi.signOut();
            callback.onFailure(err);
          }
        });
      },

      totpRequired() {
        console.info('Need to set TOTP');
        modalWithInputCodeOTP((code) => {
          cognitoUser.sendMFACode(code, this, 'SOFTWARE_TOKEN_MFA');
        });
      },

      newPasswordRequired(userAttributes, requiredAttributes) {
        callback.newPasswordRequired(username, cognitoUser.Session);
      },

      onFailure(err) {
        callback.onFailure(err);
      },
    });

    function getSub(userData) {
      return userData.UserAttributes.find((attr) => attr.Name === 'sub').Value;
    }

    function isEnabledMFA(userData) {
      const user = process.env.TOTP_DISABLED_USERS.split(',').find((user) => user === getSub(userData));
      return user === undefined;
    }

    async function setupMFA() {
      return new Promise((resolve, reject) => {
        cognitoUser.associateSoftwareToken({
          associateSecretCode(secretCode) {
            console.info('AssociateSecretCode');
            console.info('Display QR Code');

            const url = `otpauth://totp/${username}?secret=${secretCode}&issuer=${process.env.TOTP_ISSUER}`;
            console.info(`Your secret Code: ${secretCode}`);
            modalWithQRCode(url, (secretCode) => {
              cognitoUser.verifySoftwareToken(secretCode, 'My TOTP device', {
                onFailure(err) {
                  console.error(err.message || JSON.stringify(err));
                  reject(err);
                },
                onSuccess(result) {
                  console.info(result);
                  enableMFA().then(() => resolve());
                },
              });
            });
          },
          onFailure(err) {
            console.error(err.message || JSON.stringify(err));
          },
        });
      });
    }

    async function enableMFA() {
      return new Promise((resolve, reject) => {
        cognitoUser.setUserMfaPreference(null, totpMfaSettings, (err, result) => {
          if (err) {
            console.error(err.message || JSON.stringify(err));
            return reject(err);
          }
          console.log(`call result ${result}`);
          resolve(result);
        });
      });
    }
  };

  this.changeCogUserPassword = function (session, username, newPassword, callback) {
    const cognitoUser = _getCognitoUser(username);
    cognitoUser.Session = session;
    cognitoUser.completeNewPasswordChallenge(newPassword, [], {
      onSuccess(result) {
        callback(null, result);
      },
      onFailure(err) {
        callback(err, null);
      },
    });
  };

  this.forgotPassword = function (username, callback) {
    const cognitoUser = _getCognitoUser(username);
    cognitoUser.forgotPassword({
      onSuccess(result) {
        callback(null, result);
      },
      onFailure(err) {
        callback(err, null);
      },
    });
  };

  this.confirmPassword = function (username, verificationCode, newPassword, callback) {
    const cognitoUser = _getCognitoUser(username);
    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onSuccess(result) {
        callback(null, result);
      },
      onFailure(err) {
        callback(err, null);
      },
    });
  };

  this.signOut = function () {
    const cognitoUser = _getCurrentUser();
    if (cognitoUser != null) {
      cognitoUser.signOut();
    }
  };

  this.getApiKey = function (callback) {
    const cognitoUser = _getCurrentUser();
    if (cognitoUser == null) {
      const err = {};
      err.type = 'unauthorized_user';
      callback(err, null);
      return;
    }
    cognitoUser.getSession((err, session) => {
      if (err || !session.isValid()) {
        const error = {};
        error.type = 'unauthorized_user';
        if (err) {
          error.innerError = err;
        }
        callback(error, null);
        return;
      }
      callback(null, session.getIdToken().getJwtToken());
    });
  };

  this.isLogged = function () {
    return new Promise((resolve, reject) => {
      this.getApiKey((err) => {
        if (err) {
          reject(err);
        } else {
          resolve();
        }
      });
    });
  };

  /// ///////////private methods
  function _getCurrentUser() {
    const userPool = _getUserPool();
    const cognitoUser = userPool.getCurrentUser();
    return cognitoUser;
  }

  function _getCognitoUser(username) {
    const userPool = _getUserPool();
    const userData = {
      Username: username,
      Pool: userPool,
    };
    const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    return cognitoUser;
  }

  function _getUserPool() {
    const userPool = new AmazonCognitoIdentity.CognitoUserPool({
      UserPoolId: window.POOL_DATA_USER_ID,
      ClientId: window.POOL_DATA_CLIENT_ID,
    });
    return userPool;
  }

  function modalWithQRCode(text, callback) {
    customPopUp.setSize('sm');
    customPopUp.html(`
            <div>
                <div id="qrCodeCont" style="text-align: center;margin: 15px 0 30px;"></div>
                <p style="margin-top: 10px;">Open Authenticator App then Scan this QR code and enter the code</p>
                <div class="input-group">
                   <input type="text" id="otp-code" class="form-control" autocomplete="off" placeholder="Code" />
                   <span class="input-group-btn">
                      <button class="btn btn-primary" type="button" id="submit-code">Submit</button>
                   </span>
                </div>
                <p style="margin: 10px 0 0;"><i class="fa fa-question-circle fa-lg"></i> <a href="" class="first-use-instructions">First use instructions</a></p>
                
                <div class="instruction" style="display: none;">
                   <h3 style="text-align: center;margin-top: 10px;">Instruction</h3>
                   
                   <p><b>1.</b> Go to App Store (if using iPhone) or Play Store (if using Android)</p>
                   <p><b>2.</b> Search for, and install the <code>Google Authenticator</code></p>
                   <p><b>3.</b> Open the Authenticator app</p>
                   <p><b>4.</b> Tap "Get Started". This takes you to the "Setup your first account" screen.</p>
                   <p><b>5.</b> Select a setup method named: "Scan a QR code"</p>
                   <p><b>6.</b> Scan the QR code you see on this page. A number will be displayed on your phone.</p>
                   <p style="margin-bottom: 0"><b>7.</b> Enter that number on this page</i></p>
                </div>
            </div>
        `);
    const $qrCodeCont = $('#qrCodeCont');
    $qrCodeCont.qrcode({
      text,
      size: 240,
      mode: 0,
      mSize: 0.045,
      mPosX: 0.5,
      mPosY: 0.5,
      fontcolor: '#000',
      fontname: 'Arial',
      ecLevel: 'H',
      render: 'image',
    });
    customPopUp.show();
    const handler = () => {
      const code = $('#otp-code').val();
      callback(code);
      customPopUp.hide();
    };
    $('#otp-code').on('keyup', (e) => {
      if (e.keyCode === 13) {
        handler();
      }
    });
    $('#submit-code').on('click', handler);

    $('.first-use-instructions').on('click', (e) => {
      e.preventDefault();
      $('.instruction').toggle();
    });
  }

  function modalWithInputCodeOTP(callback) {
    customPopUp.setSize('sm');
    customPopUp.html(`
            <div>
               <p>${langOTP.inputCode.title}</p>
               <div class="input-group">
                  <input type="text" id="otp-code" class="form-control" autocomplete="off" placeholder="Code" />
                  <span class="input-group-btn">
                    <button class="btn btn-primary" type="button" id="submit-code">${langOTP.inputCode.submit}</button>
                  </span>
                </div>
                <p class="subtext-otp mt-1">${langOTP.inputCode.subtext}</p>
            </div>
        `);
    customPopUp.show(() => {
      $('#otp-code').focus();
    });
    const handler = () => {
      const code = $('#otp-code').val();
      callback(code);
      customPopUp.hide();
    };
    $('#otp-code').on('keyup', (e) => {
      if (e.keyCode === 13) {
        handler();
      }
    });
    $('#submit-code').on('click', handler);
  }
}
export default cognitoApi;
